import React, { useCallback, useEffect, useMemo, useState } from "react";
import { MdErrorOutline } from 'react-icons/md'
import { Rating } from "react-simple-star-rating";

import { ReactComponent as CloseButtonSvg } from '../../assets/ExitDelete.svg'
import { ReactComponent as ConfirmIcon } from '../../assets/ConfirmIcon.svg'
import { ReactComponent as BackArrow } from '../../assets/backArrow.svg'

import MaisConteudoAPi from "../../services/MaisConteudoAPi";
import useUser from "../../hooks/UserContext";
import ModalBackdrop from "../ModalBackdrop";
import NpsModal from "../NpsModal";
import FooterButton from "../FooterButton";
import TextArea from "../Inputs/TextArea/TextArea";

import { ExiteButtonContainer } from "../Modal/styles";
import * as Styles from "./styles";
import { onDisabledScrollHandler } from "../../utils/ScrollHandler";

interface IShowNpsProps {
  isOpen: boolean;
  onClose: () => void;
}
interface IErrorState {
  error: string;
  isToShow: boolean;
}

const Nps: React.FC<IShowNpsProps> = ({ isOpen, onClose }) => {
  const [text, setText] = useState<string>('');
  const [returnMessage, setReturnMessage] = useState<string>('');
  const [openReturnMessage, setOpenReturnMessage] = useState<boolean>(false);
  const [disabled, setDisabled] = useState(false)
  const [error, setError] = useState<IErrorState>({ error: '', isToShow: false })
  const [score, setScore] = useState(0);
  const [formStepsNum, setFormStepsNum] = useState(0);
  const [render, setRender] = useState<boolean>(false);

  const { userInfo } = useUser();

  const handleScore = useCallback((rate: React.SetStateAction<number>) => {
    setScore(rate);
  }, []);

  const response = () => {
    switch (score) {
      case 1:
      case 2:
        return "Poxa, que pena. O que acha de nos dizer no que podemos melhorar?";
      case 3:
        return "Nada mau! O que podemos melhorar?";
      case 4:
      case 5:
        return "Uau, isso é ótimo! Nossa equipe adoraria saber qual é o principal motivo da sua pontuação alta:";
    }
  };
  const onClearErrorHandler = useCallback(() => setOpenReturnMessage(false), [])

  const onSubmitFormHandler = useCallback(async () => {
    if (!disabled) {
      try {
        setDisabled(true)
        await MaisConteudoAPi.post("/v1/nps/", {
          code: userInfo.code,
          score: score,
          description: text,
        });
        setReturnMessage("success")
        setOpenReturnMessage(true);
        localStorage.setItem('lastNps', new Date().toString())
      }
      catch (error: any) {
        setDisabled(false)
        setScore(0);
        setText('');
        setReturnMessage("error")
        setOpenReturnMessage(true);
        setError({
          error: error.response?.data.message || "Ops... algo de errado aconteceu, tente a pesquisa de satisfação novamente!",
          isToShow: true
        })
      }
    }
  }, [userInfo.code, text, score, disabled, setScore, setText, setError]);

  const onClickCallback = useCallback(() => {
    if (returnMessage === "success")
      return onClose()
    if (returnMessage === "error")
      return onClearErrorHandler()
  }, [onClearErrorHandler, onClose, returnMessage])

  const returnMessageMemo = useMemo(() => {
    switch (returnMessage) {
      case "success":
        return {
          Message: " Sua resposta foi enviada com sucesso ao nosso time. Obrigado!",
          Icon: <ConfirmIcon className="svg__icon" />,
          IconClose: <CloseButtonSvg className="svg" onClick={onClose} />,
          buttonText: "OK",
        }
      case "error":
        return {
          Message: error.error,
          Icon: <MdErrorOutline className="svg__icon" />,
          buttonText: 'PROSSEGUIR',
        }
    }
  }, [returnMessage, error.error, onClose])

  const FinishMessage = useMemo(() => {
    return (
      <Styles.Container>

        <ExiteButtonContainer>
          {returnMessageMemo?.IconClose}
        </ExiteButtonContainer>
        {returnMessageMemo?.Icon}

        <Styles.TextNps className="responseText">
          {returnMessageMemo?.Message}
        </Styles.TextNps>

        <FooterButton
          name={returnMessageMemo?.buttonText}
          onClick={onClickCallback}
          className="button"
        />

      </Styles.Container>
    )
  }, [onClickCallback, returnMessageMemo?.Icon, returnMessageMemo?.IconClose, returnMessageMemo?.Message, returnMessageMemo?.buttonText])


  const onGetLastDateHanlder = useCallback(async () => {
    const dateNow = new Date();
    try {
      const res = await MaisConteudoAPi.get("/v1/nps/")
      const tutorial = await MaisConteudoAPi.get('/v1/tutorial')

      const getLastAnswer = res.data.map((r: any) => r.createdAt)
      [res.data.map((r: any) => r.createdAt).length - 1]

      const lastAwnser = new Date(getLastAnswer);
      const difference = Math.abs(dateNow.getTime() - lastAwnser.getTime());
      const days = Math.ceil(difference / (1000 * 60 * 60 * 24));

      localStorage.setItem('lastNps', getLastAnswer)

      if ((days > 30 || res.data.length === 0) && tutorial.data !== 0) {
        setRender(true)
        onDisabledScrollHandler()
      }
    } catch (error: any) {
      console.log(error.response?.data.message || "Algo de errado aconteceu, por favor tente novamente!")
    }
  }, [])

  useEffect(() => {
    const DateNow = new Date();

    const lastDate = localStorage.getItem('lastNps')

    if (lastDate) {
      const lastAwnser = new Date(lastDate);
      const difference = Math.abs(DateNow.getTime() - lastAwnser.getTime());
      const days = Math.ceil(difference / (1000 * 60 * 60 * 24));

      if (days > 30) {
        onGetLastDateHanlder()
      }
    }

    if (!lastDate || lastDate === 'undefined') {
      onGetLastDateHanlder()
    }
  }, [onGetLastDateHanlder]);

  return (
    <ModalBackdrop isOpen={isOpen && render} onClose={() => { }} >
      <NpsModal isOpen={isOpen && render} onClose={() => { }}>
        <Styles.NpsItems>
          {!openReturnMessage ?
            <div>
              <div className={`${formStepsNum < 1 ? 'formStepActive' : 'form-step'}`}>
                <Styles.TextNps>
                  Como você classificaria sua experiência com +Lojinha?
                </Styles.TextNps>
                <Styles.RatingStyle>
                  <Rating
                    onClick={handleScore}
                    ratingValue={score}
                    fillColor={'#f1d045'}
                    emptyColor={'#757575'}
                    size={45}
                    className="rating"
                  />
                  <Styles.TextRating>
                    <small>
                      Muito <p />
                      insatisfatória
                    </small>
                    <small>
                      Muito <p />
                      satisfatória
                    </small>
                  </Styles.TextRating>
                </Styles.RatingStyle>
                <FooterButton
                  className="button btn btn-next "
                  name={"PROSSEGUIR"}
                  onClick={() => {
                    setFormStepsNum((prev) => prev + 1)
                  }}
                  disabled={!score}
                />
              </div>
              <div className={`${formStepsNum > 0 ? 'formStepActive' : 'form-step'}`}>
                <Styles.BackButton onClick={() => { setFormStepsNum((prev) => prev - 1); }}>
                  <button className="btn || btn-prev ">
                    <BackArrow className="arrow" />
                    VOLTAR
                  </button>
                  <CloseButtonSvg className="svg" onClick={onSubmitFormHandler} />
                </Styles.BackButton>
                <Styles.TextInput>{response()}</Styles.TextInput>
                <TextArea
                  className="input"
                  value={text}
                  onTextAreaChange={(e) => setText(e.currentTarget.value)}
                  id={"input"}
                />
                <FooterButton
                  name={"ENVIAR"}
                  onClick={onSubmitFormHandler}
                  className="button"
                />
              </div>
            </div>
            :
            FinishMessage
          }
        </Styles.NpsItems>
      </NpsModal>
    </ModalBackdrop>
  );
};

export default Nps;
